import React, { memo, useEffect, useState } from 'react';
import { Box, CircularProgress, SxProps } from '@mui/material';
import { UIStatusGroup } from '../types';
import dynamic from 'next/dynamic';

const VigoOpenMap = dynamic(() => import('src/@vigo/vigo-openMap'), { ssr: false });

const HEIGHT = 300;

interface PodLocationMapProps {
  statusGroups?: UIStatusGroup[];
  sx?: SxProps;
}

const PodLocationMap = ({ statusGroups, sx = {} }: PodLocationMapProps) => {
  const [reveal, setReveal] = useState<boolean>(false);
  const deliveredStatusGroup = statusGroups?.find(
    group => (group.code as string | undefined)?.trim()?.toLowerCase() === 'delivered'
  );

  const statusHistoryOrdered = deliveredStatusGroup?.items
    ?.filter(item => Boolean(item?.statusDate))
    .sort((a, b) => {
      return new Date(b.statusDate!).getTime() - new Date(a.statusDate!).getTime();
    });

  const podItem = statusHistoryOrdered?.[0];

  const latitude = podItem?.latitude;
  const longitude = podItem?.longitude;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setReveal(true);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!podItem || !latitude || !longitude) {
    return null;
  }

  if (!reveal && podItem && latitude && longitude) {
    return (
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          width: '100%',
          minHeight: `${HEIGHT}px`,
          backgroundColor: '#acacac',
          borderRadius: '8px',
          marginTop: '20px'
        }}>
        <CircularProgress size={'20px'} />
      </Box>
    );
  }

  return <VigoOpenMap lat={latitude} lon={longitude} zoom={16} height={HEIGHT} sx={sx} isStatic />;
};

export default memo(PodLocationMap);
